import React, { memo, forwardRef } from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export const IconSearchTimes = memo(
  forwardRef((props, ref) => {
    return (
      <SvgIcon
        {...props}
        ref={ref}
        viewBox="0 0 20 20"
        data-fill-none
      >
        <path
          d="M15.2515 8.32861C15.2517 9.69794 14.8458 11.0366 14.0851 12.1752C13.3244 13.3138 12.2432 14.2013 10.9781 14.7254C9.71305 15.2495 8.32098 15.3866 6.97795 15.1195C5.63493 14.8524 4.40128 14.193 3.43301 13.2248C2.46475 12.2565 1.80537 11.0228 1.53827 9.67982C1.27116 8.3368 1.40832 6.94472 1.93241 5.67966C2.4565 4.41459 3.34398 3.33335 4.4826 2.57269C5.62121 1.81202 6.95984 1.4061 8.32916 1.40625C10.1651 1.40625 11.9258 2.13557 13.224 3.43376C14.5222 4.73196 15.2515 6.49269 15.2515 8.32861Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.85059 5.85156L10.712 10.713"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.85059 10.713L10.712 5.85156"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.2246 13.2227L18.594 18.5928"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </SvgIcon>
    );
  })
);
